<ra-modal
    [title]="(isItems() ? 'document.edit.quote.catalog.titleItems' : 'document.edit.quote.catalog.titleTaxes') | translate"
    [size]="'large'"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="catalog-body">
        <p class="catalog-hint">{{ 'document.edit.quote.catalog.hint' | translate }}</p>

        @if (fetching())
        {
            <div class="catalog-loading">
                <ra-loading />
            </div>
        }
        @else if (catalogIsEmpty())
        {
            <ra-empty
                [title]="(isItems() ? 'document.edit.quote.catalog.emptyItemsTitle' : 'document.edit.quote.catalog.emptyTaxesTitle') | translate"
                [message]="'document.edit.quote.catalog.emptyMessage' | translate"
                [marginTop]="24" />
        }
        @else
        {
            <ra-input
                [formControl]="searchControl"
                [leftIcon]="'search-normal'"
                [placeholder]="'document.edit.quote.catalog.searchPlaceholder' | translate"
                [showRequiredOrOptional]="false"
                [showLimitCharacters]="false"
            />

            @if (searchHasNoResult())
            {
                <ra-empty
                    [title]="'document.edit.quote.catalog.noResultTitle' | translate"
                    [message]="'document.edit.quote.catalog.noResultMessage' | translate"
                    [marginTop]="24" />
            }
            @else if (isItems())
            {
                <div class="catalog-list">
                    @for (item of filteredItems(); track item._id)
                    {
                        <div class="catalog-row">
                            <div class="catalog-info">
                                <span class="catalog-name">{{ item.name }}</span>
                                <span class="catalog-meta">
                                    {{ item.unitOfMeasurement | unitOfMeasurementFormat }}
                                    ·
                                    {{ item.unitPrice | raCurrency: currencyCode() : locale() }}
                                </span>
                            </div>

                            <div class="catalog-actions">
                                <ra-input
                                    class="catalog-qty"
                                    [formControl]="qtyControl(item)"
                                    [type]="'number'"
                                    [label]="'document.edit.quote.catalog.quantity' | translate"
                                    [showRequiredOrOptional]="false"
                                    [showLimitCharacters]="false"
                                />
                                <ra-button
                                    [label]="'document.edit.quote.catalog.add' | translate"
                                    [type]="'primary'"
                                    [disabled]="!canAddItem(item)"
                                    (click)="onAddItem(item)"
                                />
                            </div>
                        </div>
                    }
                </div>
            }
            @else
            {
                <div class="catalog-list">
                    @for (taxe of filteredTaxes(); track taxe._id)
                    {
                        <div class="catalog-row">
                            <div class="catalog-info">
                                <span class="catalog-name">{{ taxe.name }}</span>
                                <span class="catalog-meta">
                                    {{ (taxe.mode === 'percentage' ? 'document.edit.quote.modePercentage' : 'document.edit.quote.modeFixed') | translate }}
                                    ·
                                    @if (taxe.mode === 'percentage')
                                    {
                                        {{ formatPercent(taxe.price) }}
                                    }
                                    @else
                                    {
                                        {{ taxe.price | raCurrency: currencyCode() : locale() }}
                                    }
                                </span>
                            </div>

                            <div class="catalog-actions">
                                <ra-button
                                    [label]="'document.edit.quote.catalog.add' | translate"
                                    [type]="'primary'"
                                    [disabled]="loading()"
                                    (click)="onAddTaxe(taxe)"
                                />
                            </div>
                        </div>
                    }
                </div>
            }
        }
    </div>

    <div class="catalog-footer">
        <ra-button
            [label]="'common.close' | translate"
            [type]="'primary-outline'"
            [disabled]="loading()"
            (click)="close.emit()"
        />
    </div>
</ra-modal>
